import React, { useMemo } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import {
  getCourseTypeDotStyle,
  courseTypeToDotSlug,
  sortCourseTypesForCalendar,
} from '../utils/courseTypeColors';

const DOT_SIZE = 9;

function buildDotItems(courseTypes, fallbackSessionCount) {
  const sorted = sortCourseTypesForCalendar(courseTypes);
  if (sorted.length) {
    return sorted.map((type) => ({
      key: type,
      typeSlug: courseTypeToDotSlug(type),
      courseType: type,
    }));
  }
  if (fallbackSessionCount > 0) {
    return [{ key: 'fallback', typeSlug: 'default', courseType: null }];
  }
  return [];
}

export default function TrainingCalendarDayDots({
  courseTypes,
  fallbackSessionCount = 0,
  style,
  dotSize = DOT_SIZE,
}) {
  const theme = useTheme();
  const items = useMemo(
    () => buildDotItems(courseTypes, fallbackSessionCount),
    [courseTypes, fallbackSessionCount]
  );
  if (!items.length) return null;

  return (
    <View
      style={[styles.dotsRow, style]}
      {...(Platform.OS === 'web'
        ? {
            dataSet: { trainingCalendarDotsRow: 'true' },
            className: 'training-calendar-dots-row',
          }
        : {})}
    >
      {items.map((item) => {
        const dotStyle = getCourseTypeDotStyle(item.courseType, {
          isDarkMode: theme.isDarkMode,
        });
        return (
          <Text
            key={item.key}
            style={[
              styles.dotChar,
              {
                color: dotStyle.color,
                fontSize: dotSize,
                lineHeight: dotSize,
              },
            ]}
            {...(Platform.OS === 'web'
              ? {
                  dataSet: {
                    trainingCalendarDot: 'true',
                    trainingCalendarDotType: item.typeSlug,
                  },
                  className: `training-calendar-dot training-calendar-dot--${item.typeSlug}`,
                }
              : {})}
          >
            ●
          </Text>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  dotsRow: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    marginTop: 1,
    gap: 2,
    width: 'auto',
    maxWidth: '100%',
    backgroundColor: 'transparent',
  },
  dotChar: {
    textAlign: 'center',
    backgroundColor: 'transparent',
    includeFontPadding: false,
    padding: 0,
    margin: 0,
    width: DOT_SIZE,
    height: DOT_SIZE,
  },
});
